export const sortHighlightColor = '#3498db';
export const filterHightlightColor = '#FF9100';
